export default __webpack_public_path__ + "static/media/bg_faca_parte.bfe23e61.png";